import React, { useEffect, useState } from 'react'
import { BreathAPIs } from '../../APIs/BreathAPIs'
import { toast, ToastContainer } from 'react-toastify';
import { InputNumber, Input } from 'antd';
import { BsExclamationTriangleFill } from "react-icons/bs";
import styles from "./styles.module.css";

const CONFIRM_TEXT = "Confirm"

function BillUpdateView({selectedBooking, setShowBillUpdateEnergyModel, showBillUpdateEnergyModel}) {

const [utilizedEnergy, setUtilizedEnergy] = useState(0)
const [energyArray, setEnergyArray] = useState([])
const [confirmationText, setConfirmationText] = useState('')
const [isLoading, setIsLoading] = useState(false)
const [isSubmitting, setIsSubmitting] = useState(false)

const updateBookingBill = async() => {
    try{
        setIsSubmitting(true)
        let response = await BreathAPIs.manualBillBooking(selectedBooking._id, energyArray)
        toast.success(response?.data?.message)
        setShowBillUpdateEnergyModel(false)
    }catch(err){
        console.log('err in updating: ', err)
        toast.error(err?.response?.data?.message)
    }finally{
        setIsSubmitting(false)
    }
}

const getSessionDetails = async(bookingId) => {
    try{
        let totalUtilizedEnergy = 0
        let energyRows = []
       let response = await BreathAPIs.getBookingSession(bookingId)
       if(response){
            for (let data of response.data){
                for (const [key, value] of Object.entries(data?.energyData || {})) {
                    totalUtilizedEnergy += value?.energy
                    energyRows.push([value?.energy, value?.rate])
                    }

       }
       }
       setEnergyArray(energyRows)
       setUtilizedEnergy(totalUtilizedEnergy)

    }catch(err){
        console.log('err in fetcing session data; ', err)
        toast.error("error in fetching data")
    }finally{
        setIsLoading(false)
    }
}

useEffect(()=>{
    if(selectedBooking){
        setIsLoading(true)
        getSessionDetails(selectedBooking?._id)
    }
}, [selectedBooking])

const updatedTotal = energyArray.reduce((sum, item) => sum + (item[0] || 0), 0)

  return (
    <div className={styles['bill-update']}>
        <ToastContainer></ToastContainer>
        <div className={styles['refund-header-container']}>
            <span className={styles['refund-heading']}>Update Session Energy</span>
            {!isLoading && <span className={styles['bill-update-total']}>{Number(utilizedEnergy || 0).toFixed(3)} kWh</span>}
        </div>

        {isLoading ?
        <div className={styles['bill-update-loading']}>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Loading session data...
        </div> :
        <>
            <div className={styles['bill-update-panel']}>
                {energyArray.length === 0 ?
                    <div className={styles['bill-update-empty']}>No energy data found for this session.</div> :
                    energyArray.map((val, index) => (
                        <div className={styles['bill-update-row']} key={index}>
                            <span className={styles['bill-update-row-label']}>Interval {index + 1}</span>
                            <label className={styles['bill-update-field']}>
                                <span>Utilized Energy (kWh)</span>
                                <InputNumber
                                    min={0}
                                    value={val[0]}
                                    onChange={(value)=>{
                                        setEnergyArray(currentArray => currentArray.map((item, itemIndex) =>
                                            itemIndex === index ? [value, item[1]] : item
                                        ))
                                    }}
                                />
                            </label>
                            <label className={styles['bill-update-field']}>
                                <span>Rate per kWh ($)</span>
                                <InputNumber
                                    min={0}
                                    value={val[1]}
                                    onChange={(value)=>{
                                        setEnergyArray(currentArray => currentArray.map((item, itemIndex) =>
                                            itemIndex === index ? [item[0], value] : item
                                        ))
                                    }}
                                />
                            </label>
                        </div>
                    ))
                }
                {energyArray.length > 0 &&
                    <div className={`${styles['bill-update-row']} ${styles['big']}`}>
                        <span>Updated Total</span>
                        <span>{Number(updatedTotal).toFixed(3)} kWh</span>
                    </div>
                }
            </div>

            <div className={styles['bill-update-warning']}>
                <BsExclamationTriangleFill />
                <span>
                    The booking and billing will be updated with the energy data above. This action can't be reversed.
                    Type <strong>{CONFIRM_TEXT}</strong> to proceed.
                </span>
            </div>

            <div className={styles['bill-update-actions']}>
                <Input value={confirmationText} onChange={(e)=>{setConfirmationText(e.target.value)}} placeholder={CONFIRM_TEXT} />
                <button
                    type="button"
                    className={styles['refund-submit']}
                    disabled={confirmationText !== CONFIRM_TEXT || isSubmitting || energyArray.length === 0}
                    onClick={()=>{updateBookingBill()}}
                >
                    {isSubmitting ? 'Updating...' : 'Update Booking'}
                </button>
            </div>
        </>}
    </div>
  )
}

export default BillUpdateView
